import React from 'react';
import styled from 'styled-components';

const StyledBreadcrumbs = styled.div``;

//@todo: This function is not implemented yet.
export default function Breadcrumbs({ breadcrumbs }) {
  if (!breadcrumbs) return null;

  return (
    <StyledBreadcrumbs>
      <div>Not implemented</div>
    </StyledBreadcrumbs>
  );
}
